import { render, staticRenderFns } from "./RiderIndex.vue?vue&type=template&id=756121fc&lang=pug"
import script from "./RiderIndex.vue?vue&type=script&lang=js"
export * from "./RiderIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports